export default "__VITE_ASSET__MAIYnlu4__"